import angular from 'angular'

import contact from './contact/contact.module'
import owner from './owner/owner.module'
import phone from './phone/phone.module'
import email from './email/email.module'

const name = 'owners'

angular.module(name, [
  contact,
  owner,
  phone,
  email,
])

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owners.module.js